import React, { useEffect, useReducer } from "react"
import classNames from "classnames"
import Button from "../../Button/Button"
import QuestionTypeDropdown from "./wrappers/QuestionTypeDropdown"
import DatePicker from "./wrappers/DatePicker"
import CreatorTypeDropdown from "./wrappers/CreatorTypeDropdown"
import { ReactComponent as ArrowTopIcon } from "../../../images/icons/arrow-top.svg"
import { reducer, initState } from "./useReducer/reducer"
import {
  toggleCollapse,
  setWholeState,
  resetForm,
} from "./useReducer/actionCreators"
import styles from "./index.module.scss"

const QuestionSearchFilter = ({
  classes,
  searchParamGroup,
  onReset,
  onSubmit,
}) => {
  const [state, dispatch] = useReducer(reducer, initState)
  useEffect(() => {
    dispatch(setWholeState(searchParamGroup))
  }, [searchParamGroup])
  return (
    <div
      className={classNames(styles.filter, classes, {
        [styles.isCollapse]: state.isCollapse,
      })}
    >
      <div className={styles.header} onClick={() => dispatch(toggleCollapse())}>
        <p className={styles.caption}>All Filters</p>
        <div className={styles.collapseIcon}>
          <ArrowTopIcon />
        </div>
      </div>
      <div className={styles.form}>
        <div className={styles.body}>
          <div className={classNames(styles.item, styles.halfOfWidth)}>
            <QuestionTypeDropdown
              selectedType={state.values.questionType}
              externalDispatch={dispatch}
            />
          </div>
          <div
            className={classNames(
              styles.item,
              styles.dateField,
              styles.halfOfWidth,
            )}
          >
            <DatePicker
              fromDate={state.values.fromDate}
              toDate={state.values.toDate}
              externalDispatch={dispatch}
            />
          </div>
          <div className={classNames(styles.item)}>
            <CreatorTypeDropdown
              selectedType={state.values.creatorType}
              externalDispatch={dispatch}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            buttonStyle="outlined"
            className={styles.btn}
            onClick={() => {
              dispatch(resetForm())
              onReset()
            }}
          >
            Clear
          </Button>
          <Button className={styles.btn} onClick={() => onSubmit(state.values)}>
            Apply
          </Button>
        </div>
      </div>
    </div>
  )
}
export default QuestionSearchFilter
